import { isSameId } from "../../helpers";
import { uid } from "@xbs/lib-state";
export default function (store, { id, card }) {
    const { cards, columnKey } = store.getState();
    const cardToCopy = cards.find(card => isSameId(card.id, id));
    if (cardToCopy) {
        const newCard = {
            ...cardToCopy,
            id: uid(),
            ...(card || {}),
        };
        store.in.exec("add-card", {
            columnId: newCard[columnKey],
            before: id,
            card: newCard,
        });
    }
}
//# sourceMappingURL=duplicate.js.map